export default "__VITE_ASSET__BPmuUYZZ__"